import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetSectoreInformationProject = createAsyncThunk(
  "SectoreInformationProject/GetSectoreInformationProject",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SO_sectorAndProjectOriginalityInfo/GetsectorAndProjectOriginality",
        {
          aI_ApplicationInformationId: aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result.result; // Assuming response has a "data" field
      //console.log(data, "data");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateSectoreInformationProject = createAsyncThunk(
  "SectoreInformationProject/ValidateSectoreInformationProject",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SO_sectorAndProjectOriginalityInfo/ValidatesectorAndProjectOriginality",
        {
          aI_ApplicationInformationId: aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });

        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const SectoreInformationProject = createSlice({
  name: "SectoreInformationProject",
  initialState: {
    SectoreInformationProject: {},
    loadingGetSectoreInformationProject: false,
    errorGetSectoreInformationProject: null,

    SectoreInformationProjectValidate: [],
    loadingSectoreInformationProjectValidate: false,
    errorSectoreInformationProjectValidate: null,
  },
  reducers: {
    SetSectoreInformationProject: (state, action) => {
      state.SectoreInformationProject = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetSectoreInformationProject.pending, (state, action) => {
        state.loadingGetSectoreInformationProject = true;
        state.SectoreInformationProject = action.payload;
        state.errorGetSectoreInformationProject = null;
      })
      .addCase(GetSectoreInformationProject.fulfilled, (state, action) => {
        state.loadingGetSectoreInformationProject = false;
        state.SectoreInformationProject = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetSectoreInformationProject.rejected, (state, action) => {
        state.loadingGetSectoreInformationProject = false;
        state.errorGetSectoreInformationProject = action.payload;
      })

      .addCase(ValidateSectoreInformationProject.pending, (state, action) => {
        state.loadingSectoreInformationProjectValidate = true;
        state.SectoreInformationProjectValidate = action.payload;
        state.errorSectoreInformationProjectValidate = null;
      })
      .addCase(ValidateSectoreInformationProject.fulfilled, (state, action) => {
        state.loadingSectoreInformationProjectValidate = false;
        state.SectoreInformationProjectValidate = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidateSectoreInformationProject.rejected, (state, action) => {
        state.loadingSectoreInformationProjectValidate = false;
        state.errorSectoreInformationProjectValidate = action.payload;
      });
  },
});
export const { SetSectoreInformationProject } = SectoreInformationProject.actions;

export default SectoreInformationProject.reducer;
